import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import contentClient from '../../../../../utils/apiClients/contentClient';
import dataSchemasClient from '../../../../../utils/apiClients/dataSchemasClient';
import getPrettyError from '../../../../../utils/getPrettyError';
import rootReducer from './reducers/rootReducer';
import { fromXml, toXml } from './serializers';
import pathUtil from '../../../../../utils/pathUtil';
import { saveCsvContent } from '../apiClients/csvDataClient';
var DashboardStateContext = React.createContext(null);
var DashboardDispatchContext = React.createContext(null);

function DocumentProvider(_ref) {
  var children = _ref.children;

  var _React$useReducer = React.useReducer(rootReducer, null),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return React.createElement(DashboardStateContext.Provider, {
    value: state
  }, React.createElement(DashboardDispatchContext.Provider, {
    value: dispatch
  }, children));
}

function useDocumentState() {
  var context = React.useContext(DashboardStateContext);

  if (context === undefined) {
    throw new Error('useDashboardState must be used within a DashboardStateContext');
  }

  return context;
}
/**
 * @return {import('./types').documentDispatch}
 */


function useDocumentDispatch() {
  var context = React.useContext(DashboardDispatchContext);

  if (context === undefined) {
    throw new Error('useDashboardDispatch must be used within a DashboardDispatchContext');
  }

  return context;
}
/**
 * @param {import('./types').documentDispatch} dispatch
 */


function reset(_x, _x2, _x3) {
  return _reset.apply(this, arguments);
}
/**
 * @param {import('./types').documentDispatch} dispatch
 */


function _reset() {
  _reset = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(dispatch, workspace, path) {
    var edmContent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            dispatch({
              type: 'reset',
              payload: {
                workspace: workspace,
                path: path
              }
            });
            _context.next = 4;
            return contentClient.getContent(workspace, path);

          case 4:
            edmContent = _context.sent;
            dispatch({
              type: 'content_fetched',
              payload: fromXml(edmContent, path)
            });
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context.t0)
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _reset.apply(this, arguments);
}

function insertSpreadsheet(_x4, _x5) {
  return _insertSpreadsheet.apply(this, arguments);
}
/**
 * @param {import("./types").documentDispatch} dispatch
 */


function _insertSpreadsheet() {
  _insertSpreadsheet = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(dispatch, _ref2) {
    var basePath, workspace, path, id;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            basePath = _ref2.basePath, workspace = _ref2.workspace, path = _ref2.path, id = _ref2.id;
            _context3.prev = 1;
            return _context3.abrupt("return", new Promise(
            /*#__PURE__*/
            function () {
              var _ref3 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee2(resolve, reject) {
                var schema;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return dataSchemasClient.getSchema(workspace, path);

                      case 2:
                        schema = _context2.sent;

                        if (schema.Fields.length === 0) {
                          reject('InvalidFile');
                        } else {
                          dispatch({
                            type: 'insert_spreadsheet',
                            payload: {
                              src: pathUtil.relative(path, basePath),
                              schema: schema,
                              id: id
                            }
                          });
                          resolve();
                        }

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x10, _x11) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 5:
            _context3.prev = 5;
            _context3.t0 = _context3["catch"](1);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context3.t0)
            });

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 5]]);
  }));
  return _insertSpreadsheet.apply(this, arguments);
}

function save(_x6, _x7, _x8, _x9) {
  return _save.apply(this, arguments);
}

function _save() {
  _save = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(dispatch, workspace, path, documentState) {
    var xmlContent, blob, filePath, fileCsvData;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (!(documentState.content !== documentState.serverContent)) {
              _context4.next = 6;
              break;
            }

            xmlContent = toXml(documentState.content, path);
            blob = new Blob([xmlContent], {
              type: 'text/xml'
            });
            _context4.next = 6;
            return contentClient.addFile(workspace, path, blob);

          case 6:
            _context4.t0 = _regeneratorRuntime.keys(documentState.csvData);

          case 7:
            if ((_context4.t1 = _context4.t0()).done) {
              _context4.next = 16;
              break;
            }

            filePath = _context4.t1.value;
            fileCsvData = documentState.csvData[filePath];

            if (!(fileCsvData.edits === null)) {
              _context4.next = 12;
              break;
            }

            return _context4.abrupt("continue", 7);

          case 12:
            _context4.next = 14;
            return saveCsvContent(workspace, filePath, fileCsvData.edits);

          case 14:
            _context4.next = 7;
            break;

          case 16:
            dispatch({
              type: 'document_saved',
              payload: documentState.content
            });
            _context4.next = 22;
            break;

          case 19:
            _context4.prev = 19;
            _context4.t2 = _context4["catch"](0);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context4.t2)
            });

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 19]]);
  }));
  return _save.apply(this, arguments);
}

export { DocumentProvider, useDocumentState, useDocumentDispatch, reset, insertSpreadsheet, save };